export const coursesRouteNames = {
  Courses: 'courses/courses',
  CourseSingle: 'courses/course-single',
  HoleSingle: 'courses/hole-single'
}
